import { useState } from "react";
import { X, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

const PROMO_END = new Date("2026-03-14T23:59:59");

const PromoBanner = () => {
  const [dismissed, setDismissed] = useState(false);
  const isMobile = useIsMobile();

  if (dismissed || new Date() > PROMO_END) return null;

  if (isMobile) {
    return (
      <div className="fixed inset-0 z-[100] flex items-end justify-center bg-black/50 backdrop-blur-sm">
        <div className="relative w-full mx-3 mb-4 rounded-2xl bg-gradient-to-br from-purple-600 via-pink-500 to-purple-600 p-6 text-white shadow-2xl animate-in slide-in-from-bottom-4 duration-300">
          <button
            onClick={() => setDismissed(true)}
            className="absolute right-3 top-3 p-1 hover:bg-white/20 rounded-full transition-colors"
            aria-label="Dismiss banner"
          >
            <X className="w-5 h-5" />
          </button>
          <div className="flex flex-col items-center text-center gap-3">
            <Sparkles className="w-6 h-6" />
            <p className="text-base font-bold leading-snug">
              🎉 International Women's Day Special
            </p>
            <p className="text-sm opacity-90">
              25% off Hydra OS websites for women-owned trades businesses!
            </p>
            <Link
              to="/womens-day"
              onClick={() => setDismissed(true)}
              className="mt-1 inline-block rounded-full bg-white text-purple-700 px-6 py-2.5 text-sm font-bold shadow-lg hover:bg-white/90 transition-colors"
            >
              Learn more →
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative z-50 bg-gradient-to-r from-purple-600 via-pink-500 to-purple-600 text-white">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-2 text-center text-xs sm:text-sm font-medium">
        <Sparkles className="w-4 h-4 shrink-0" />
        <span>
          🎉 <strong>International Women's Day Special</strong> — 25% off Hydra OS websites for women-owned trades businesses!{" "}
          <Link to="/womens-day" className="underline underline-offset-2 font-bold hover:text-white/90">
            Learn more →
          </Link>
        </span>
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded transition-colors"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;